import { orpc } from "@/utils/orpc.client";

interface ReleaseQueryOptionsInput {
  id: string;
  locale?: string;
}

export function getReleaseQueryOptions({ id, locale }: ReleaseQueryOptionsInput) {
  return orpc.music.getRelease.queryOptions({
    input: { id, locale },
  });
}
